import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const probationaryPeriodFilterLabel = () => t({ message: 'Probationary period', comment: 'Insights: Probationary period filter' });
export function ProbationaryPeriodFilter() {
    return <BooleanFilter name="metadataDocumentProbationaryPeriod" label={probationaryPeriodFilterLabel()}/>;
}
